import React, { useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";

import SplitNumber from "../../../components/SplitNumber";
import CounterButton from "./CounterButton";
import { IconArrowRight } from "../../../../assets/icons";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import _, { size } from "lodash";
function ReserveModal({ showReserveModal, setShowReserveModal, data }) {
  const [totalCount, setTotalCount] = useState(1);
  const navigate = useNavigate();
  const handleClose = () => {
    setShowReserveModal(false);
  };

  data.packageItemsArray =
    _.isArray(data.packageItemsArray) && data.packageItemsArray.length > 0
      ? data.packageItemsArray
      : [];
  const startDate = data.startDate.split("T")[0].replaceAll("-", "/");
  const endDate = data.endDate.split("T")[0].replaceAll("-", "/");
  // const packagePrice = data.packageItemsArray.reduce(
  //   (sum, packages) => sum + parseInt(packages.originalPrice),
  //   0
  // );
  const packagePrice = data.price;
  // console.log("data.packageItemsArray", data.packageItemsArray)

  // const packageFinalPrice = data.packageItemsArray.reduce(
  //   (sum, packages) => sum + parseInt(packages.price),
  //   0
  // );
  const packageFinalPrice = data.originalPrice;
  const sweetAlertModal = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-outline-success mt-2",
    },
    buttonsStyling: false,
  });

  const addToBasket = () => {
    const imagesHtml = data.packageItemsArray
      .map(
        (packageItemData) =>
          `<img
        src="https://localhost:9003${packageItemData.imageUrl}"
        alt = "image1"
        class= "rounded-circle"
        /> `
      )
      .join("");
    sweetAlertModal
      .fire({
        icon: "success",
        title: " پکیج زیر به سبد خرید اضافه شد.",
        showClass: {
          popup: `
            animate__animated
            animate__fadeIn
            animate__faster`,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOut
            animate__faster`,
        },
        html: `
        <div class= 'border rounded-3 px-3 py-2' >
        <div class='row'>
          <div class='col-12 pb-2'>
            <div class='d-flex aling-items-center justify-content-center rounded-image rounded-image-sm'>
              ${imagesHtml}
            </div>
          </div>
          <div class='col-12 fw-bold fs-101 pb-1'> ${data.title}</div>
          <div class='col-12 fs-065 border-bottom pb-3 mb-3'> ${data.packageItemsArray
            .map((packageItemData) => packageItemData.amusementServiceTitle)
            .join(" + ")}  </div>
          <div class='col align-items-center py-1 px-0' >
            <div class='fs-075 text-center pb-2'>بازه انجام تفریحات پکیج</div>
            <div class='fs-09  text-center fw-bold'> ${endDate} - ${startDate}</div>
          </div>
          <div class='col-auto border-start  my-auto'>
            <div class='fs-075 text-center pb-2'> تعداد پکیج</div>
            <div class='fw-bold fs-09  text-center'>${totalCount} عدد</div>
          </div>
        </div>
        </div>`,
        confirmButtonText: "تایید و پرداخت",
        // showCancelButton: "true",
        // cancelButtonText: "اضافه کردن سایر پکیج ها به سبد خرید",
      })
      .then((result) => {
        if (result.isConfirmed) {
          navigate("/basket");
        }
      });
  };

  return (
    <>
      <Modal
        show={showReserveModal}
        scrollable
        fullscreen="md-down"
        centered
        onHide={handleClose}
      >
        {/* <Modal.Header className="d-block bg-white p-2 border-bottom-0">
          <Modal.Title className="large-svg "></Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="pb-5 pt-3">
          <div className="d-flex align-items-center justify-content-center">
            <button
              type="button"
              className="btn-no-style px-0"
              onClick={handleClose}
            >
              <IconArrowRight fillColor="#000" />
            </button>
            <h1 className=" fs-normal mb-2 pb-1 text-center">
              رزرو {data.title}
            </h1>
          </div>
          <Col xs="12" className="pb-3">
            <div className="d-flex aling-items-center justify-content-center rounded-image rounded-image-sm">
              {data.packageItemsArray.map((packageItemData, index) => (
                <img
                  src={`https://localhost:9003${packageItemData.imageUrl}`}
                  alt="image1"
                  className="rounded-circle"
                />
              ))}
            </div>
          </Col>
          <Card className="rounded-3 bg-light mb-2">
            <Card.Body className=" py-2">
              <Row>
                <Col className="my-auto dash-line-after">
                  <span className="pe-2 fw-bold">تعداد پکیج</span>
                </Col>
                <Col
                  xs="auto"
                  className="text-end d-flex justify-content-end px-2"
                >
                  <CounterButton
                    totalCount={totalCount}
                    setTotalCount={setTotalCount}
                    item={data}
                    size=""
                  />
                  {/* <CounterButton totalCount={10} /> */}
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="rounded-3 bg-light">
            <Card.Body>
              <Row className="opacity-75  fs-075 pb-2 border-bottom mb-2 ">
                <Col xs>آیتم های پکیج</Col>
                <Col xs="2" className="text-center px-0">
                  تـعداد
                </Col>
                <Col xs="4" className="my-auto text-center">
                  قیـمت
                </Col>
              </Row>
              {data.packageItemsArray.map((packageItemData, index) => (
                <Row className="fs-075 py-2" key={index}>
                  {/* dash-line-after */}
                  <Col xs className="my-auto pe-0">
                    <span className="pe-2">
                      {packageItemData.amusementServiceTitle}
                    </span>
                    <div className="text-black-06 fs-07">
                      ({packageItemData.title})
                    </div>
                  </Col>

                  <Col
                    xs="2"
                    className="text-center d-flex justify-content-center px-0 my-auto"
                  >
                    {packageItemData.countPerReserve * totalCount}
                  </Col>
                  <Col xs="4" className="my-auto text-center px-0">
                    <div className="">
                      <span className="text-decoration-line-throught-rotate border-secondary text-black-06  fs-07">
                        <SplitNumber number={packageItemData.originalPrice} />
                        <span className="fs-065">تومان</span>
                      </span>
                    </div>
                    <div className="fw-bold">
                      <SplitNumber
                        number={packageItemData.price * totalCount}
                      />
                      <span className="fs-065">تومان</span>
                    </div>
                  </Col>
                </Row>
              ))}
            </Card.Body>
          </Card>
          <Card className="rounded-3 bg-light mt-2">
            <Card.Body className=" py-2">
              <Row>
                <Col className="my-auto">مبلغ قابل پرداخت</Col>
                <Col className="text-end">
                  <div>
                    <span className="text-decoration-line-throught-rotate border-secondary text-black-06 fs-07">
                      <SplitNumber number={packagePrice * totalCount} />
                      <span className="fs-065">تومان</span>
                    </span>
                  </div>
                  <div className="fw-bold fs-101">
                    <SplitNumber number={packageFinalPrice * totalCount} />{" "}
                    تومان
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Button
            variant="success"
            className="w-100 mt-2 mb-5 "
            onClick={addToBasket}
          >
            افزودن به سبد خرید
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ReserveModal;
